export default "__VITE_ASSET__utp_Yf6J__"